import { api } from './api'

/**
 * The shop section (B5): the catalogue, the learner's wallet, and the four
 * things it can do with it. Coins are earned on the server when an attempt
 * is scored; nothing here grants any. Every write is one transaction on
 * the server and answers `{ outcome, wallet }` — the wallet after it.
 */

export async function shopCatalog() {
  const { data } = await api.get('/shop/catalog')
  return data
}

export async function shopWallet() {
  const { data } = await api.get('/shop/wallet')
  return data
}

/** Unlocks (and chooses) an avatar; an owned one is simply chosen. */
export async function buyAvatar(avatarId) {
  const { data } = await api.post('/shop/buy-avatar', { avatarId })
  return data
}

export async function selectAvatar(avatarId) {
  const { data } = await api.post('/shop/select-avatar', { avatarId })
  return data
}

export async function buyPack(packId) {
  const { data } = await api.post('/shop/buy-pack', { packId })
  return data
}

/** One streak day becomes the catalogue's coins. */
export async function convertStreak() {
  const { data } = await api.post('/shop/convert-streak', {})
  return data
}
